import { all, put, takeEvery } from "redux-saga/effects";
import { BasketActions } from "./actions";
import { checkDOAvailability, downloadRequest } from "../../api/downloadApi";

const workerStartDownloadRequest = function* (action: any): Generator<any> {

    try {
        const response = yield downloadRequest(action.payload.items, action.payload.email)


        // Clear the basket after successful download request
        if (response.success) {
            yield put({ type: BasketActions.DOWNLOAD_REQUEST_SUCCESS, payload: response });
            yield put({ type: BasketActions.CLEAR_BASKET });
        } else {
            console.warn('Download request was not successful:', response);
            yield put({ type: BasketActions.DOWNLOAD_REQUEST_ERROR, payload: response.message || 'Download request was not successful.' });
        }
    } catch (error) {
        console.error('Download request failed:', error);
        yield put({ type: BasketActions.DOWNLOAD_REQUEST_ERROR, payload: error });
    }
}

const workerCheckDOAvailability = function* (action: any): Generator<any> {
    try {
        const response = yield checkDOAvailability(action.payload.identifier);
        yield put({ type: BasketActions.CHECK_DO_AVAILABILITY_SUCCESS, payload: response });
    } catch (error) {
        console.error('Check DO availability failed:', error);
        yield put({ type: BasketActions.CHECK_DO_AVAILABILITY_ERROR, payload: error });
    }
};


export function* watcherBasketActions() {
    yield all([
        takeEvery(BasketActions.START_DOWNLOAD_REQUEST, workerStartDownloadRequest),
        takeEvery(BasketActions.CHECK_DO_AVAILABILITY, workerCheckDOAvailability)
    ])
}